import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { ProviderService } from '@lib/provider/provider.service';
import { Provider, ProviderSingleResponse } from '@lib/api/models/provider';

export interface ProviderRemoveData {
    provider: Provider;
    regionId: string;
}

@Component({
    selector: 'app-prompt-region-provider-remove-dialog',
    imports: [ComponentsModule, ErrorPanelComponent],
    templateUrl: './prompt-region-provider-remove-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-region-provider-remove-dialog.component.scss'
})
export class PromptRegionProviderRemoveDialogComponent {

    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _providerService = inject(ProviderService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly data = inject<ProviderRemoveData>(DIALOG_DATA);

    removeRequest = new SendableRequest<ProviderSingleResponse, void>({
        request: () => this._providerService.removeRegion(this.data.provider.id, this.data.regionId),
        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Provider removed from region successfully',
                actions: [{ id: 'ok', label: 'OK' }]
            });
            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Failed to remove provider from region',
                actions: [{ id: 'ok', label: 'OK' }]
            });
        }
    });

    remove() {
        this.removeRequest.send();
    }

    public static show(dialog: DialogService, data: ProviderRemoveData) {
        return dialog.openDialog<DialogRef, ProviderRemoveData>(PromptRegionProviderRemoveDialogComponent, {
            data
        });
    }
}
